module.exports = __webpack_public_path__ + "static/media/bi4.947a2082.png";